import BaseService from '@src/services/BaseService'

class PhotoGalleryService extends BaseService {
    constructor() {
        super('dashboards/photo-gallery')
    }
}

export default new PhotoGalleryService()
